import { createBasicSelector } from 'util/redux'
import { billingUsageKeyFeature } from '../../featureTypes'
import { selectLocalUsage } from './selectLocalUsage'

export const selectLocalUsageForFeature = createBasicSelector(
  selectLocalUsage,
  (_state, feature) => feature,
  (usage, feature) => {
    const key = billingUsageKeyFeature(feature)
    return usage[key]
  }
)
